import React from 'react';
import ReactDOM from 'react-dom';

import { AnonymousGatePageLoader } from './AnonymousGatePage';

ReactDOM.render(<AnonymousGatePageLoader />, document.getElementById('root'));
